import { Actions, thunk } from 'easy-peasy';

import api from '~/services/api';

import { IReportsActions, IThunkGetDashboardAvailableTeamIds } from '../types';

const onGetDashboardAvailableTeamIds: IThunkGetDashboardAvailableTeamIds = thunk(
  async ({ setDashboardAvailableTeamIds }: Actions<IReportsActions>, payload) => {
    const { clinicId, isAdmin } = payload;

    const teamIds = isAdmin
      ? await api.actTeam
          .getClinicActTeams(clinicId, { pageNumber: 1, pageSize: 5000 })
          .then(r => (r.data.items || []).map(team => team.id))
      : await api.actTeam
          .getActTeamsAvailable(clinicId)
          .then(r => (r.data || []).map(team => team.id));

    setDashboardAvailableTeamIds(teamIds);

    return teamIds;
  },
);

export default onGetDashboardAvailableTeamIds;
